module.exports = __webpack_public_path__ + "sx1-2ee0c373.png";